var _path, _circle, _circle2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNpsIndifferent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49998 14.6673C12.1819 14.6673 15.1666 11.6826 15.1666 8.00065C15.1666 4.31875 12.1819 1.33398 8.49998 1.33398C4.81808 1.33398 1.83331 4.31875 1.83331 8.00065C1.83331 11.6826 4.81808 14.6673 8.49998 14.6673Z",
    stroke: "#F2BD00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.83331,
    cy: 7.66602,
    r: 1,
    fill: "#F2BD00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1667,
    cy: 7.66602,
    r: 1,
    fill: "#F2BD00"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.66669,
    y1: 10.834,
    x2: 11.3334,
    y2: 10.834,
    stroke: "#F2BD00",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpsIndifferent);
export default __webpack_public_path__ + "static/media/NpsIndifferent.d7c11875.svg";
export { ForwardRef as ReactComponent };